<div *ngIf='!isLoggedIn && !isRegistered && !(usedSSO$ | async)'
     class='container'>
  <h2>Login</h2>
  <form [formGroup]='form' (ngSubmit)='onSubmitLoginForm()'>
    <div class='form-group'>
      <app-email-input [parentForm]='form' [inputcss]='setInputOutlineClass(email)'></app-email-input>
    </div>
    <div class='form-group mt-3'>
      <app-password-input [parentForm]='form' [inputcss]='setInputOutlineClass(password)'
                          [showConfirmPassword]='false'></app-password-input>
    </div>
    <button type='submit' class='btn btn-primary mt-3 w-100' [disabled]='isFormSubmitDisabled()'>Login</button>
  </form>

  <div class='auth-link-text mt-3'>
    <p>Forgot your password? </p><a [routerLink]="['/auth/forget-password']">Reset it here.</a>
  </div>

  <div class='auth-link-text'>
    <p>Want to sign up? </p><a [routerLink]="['/auth/register']">Sign up here.</a>
  </div>
</div>
<div *ngIf='isLoading' class='text-center mb-2'>
  <i class='fa fa-spinner fa-spin fa-3x' aria-hidden='true'></i>
</div>

<div class='text-center mb-5' *ngIf='isRegistered'>
  <img *ngIf='!isInsightsDomain()' class='logo' src='assets/logo/altiuslife_logo.png' alt=''>  
  <div class='info-box' [class.mt-5]='isInsightsDomain()'>
    <p>Thank you for registering your {{isInsightsDomain() ? 'AltiusInsights' : 'AltiusLife'}} account.</p>
    <p>Please check your email for a verification link.</p>
  </div>
</div>
